import GraphPerformance from './component'

export default GraphPerformance
